<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="tentativasContato"
            sort-by="data"
        >
            <template v-slot:cell(detalhes)="{ item }">
                <rkm-button
                    :id="uniqueId(`detalhes-${item.id}`)"
                    small
                >
                    <rkm-icon icon="comment"/>
                </rkm-button>

                <rkm-popover
                    :target="uniqueId(`detalhes-${item.id}`)"
                    triggers="hover"
                    placement="top"
                >
                    {{ item.detalhes }}
                </rkm-popover>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="print(item)"
                    color="primary"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
// Mixins.
import { repository, error, formats, file } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.regulacao')
        }
    },
    data() {

        return {
            fields: [
                {
                    key: 'data',
                    label: 'Data',
                    sortable: true,
                    formatter: data => this.formatDate(data),
                    filterByFormatted: true,
                    class: 'col-min'
                },
                { key: 'usuarioNome', label: 'Usuário que contatou', sortable: true },
                { key: 'detalhes', label: 'Detalhes', class: 'col-min text-center' },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ],
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        print(tentativaContato) {

            this.setLoading()

            this.repositories.impressao.tentativaContato(tentativaContato.id)
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [repository, error, formats, file],
    props: {
        tentativasContato: { type: Array },
    },
}
</script>